import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

const PriceTypeField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="priceTypeLabel" value={restaurantForFullInfo?.priceType} />;
};

export default PriceTypeField;
